/**
 * ApplicationSkeleton - Loading placeholder for ApplicationCard
 */
import { CardSkeleton, CardGridSkeleton } from './Skeleton';

export function ApplicationSkeleton() {
  return <CardSkeleton />;
}

export function ApplicationGridSkeleton({ count = 3 }: { count?: number }) {
  return <CardGridSkeleton count={count} />;
}
